// 読み込み時のビューポート高さを固定（iOS のアドレスバー表示/非表示による変化を防ぐ）
document.documentElement.style.setProperty('--initial-vh', `${window.innerHeight}px`);

import 'instant.page';
import './lenis-smooth-scroll.js';
import './sticker-position.js';
import './sticker-random.js';
import './hamburger-menu.js';
import './roll-up-hold.js';
import './fontplus-reload.js';
